import React from 'react';

export const MultiTenantContext = React.createContext<{
    tenantId: string | undefined;
    tenantName: string | undefined;
    datavanter: boolean;
    setValue: (value: {
        tenantId: string | undefined;
        tenantName: string | undefined;
        datavanter: boolean;
    }) => void;
}>({
    tenantId: undefined,
    tenantName: undefined,
    datavanter: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setValue: () => {},
});
